import { Backdrop, CircularProgress } from "@mui/material";

export const CustomBackdrop: React.FC<any> = (props:any): JSX.Element | any => {
    return(
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={props.open}>
          <CircularProgress style={{color:'#F5F7FA'}} />
        </Backdrop>
    )
}